module.exports = __webpack_public_path__ + "img/example.3e5821ea.png";